// Remove button of a pack row in the cart drawer (snippets/cart-pack-line.liquid):
// removes every cart line of the pack at once, then refreshes the drawer like Dawn's cart.js.
if (!customElements.get('cart-pack-remove')) {
  customElements.define(
    'cart-pack-remove',
    class CartPackRemove extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        event.preventDefault();
        const cartItems = this.closest('cart-drawer-items') || this.closest('cart-items');
        if (!cartItems || this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');
        this.closest('.cart-item')?.querySelector('.loading__spinner')?.classList.remove('hidden');

        const sections = cartItems.getSectionsToRender();
        const updates = Object.fromEntries(this.dataset.keys.split(',').map((key) => [key, 0]));
        const body = JSON.stringify({
          updates,
          sections: sections.map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_update_url}.js`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((state) => {
            const isEmpty = state.item_count === 0;
            cartItems.classList.toggle('is-empty', isEmpty);
            document.querySelector('cart-drawer')?.classList.toggle('is-empty', isEmpty);
            document.getElementById('main-cart-footer')?.classList.toggle('is-empty', isEmpty);

            sections.forEach((section) => {
              const target =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);
              target.innerHTML = cartItems.getSectionInnerHTML(state.sections[section.section], section.selector);
            });
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
          })
          .catch((error) => {
            console.error(error);
            this.button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
